import { render, staticRenderFns } from "./EmailStepAccount.vue?vue&type=template&id=badf2bf0&scoped=true"
import script from "./EmailStepAccount.vue?vue&type=script&lang=js"
export * from "./EmailStepAccount.vue?vue&type=script&lang=js"
import style0 from "./EmailStepAccount.vue?vue&type=style&index=0&id=badf2bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badf2bf0",
  null
  
)

export default component.exports